export default {
  invalidEmail: "Invalid email address",
  passwordRequired: "Password is required",
  invalidLogin:
    "Incorrect email or password. Try again or use “Forgot password” if you need to reset it.",
  accountDisabled:
    "This account has been disabled. Contact support if you need help.",
  kioskRevoked:
    "This tablet access has been revoked. Ask your venue administrator for new credentials.",
  softwareIdRequired:
    "This login needs a device identifier. Use the QR login flow from your venue device, or contact support.",
  loginSuccess: "Login successful!",
  partnerPortal: "Seller Portal",
  heroTitleLine1: "Manage your",
  heroTitleLine2: "business with ease",
  heroSubtitle:
    "The dedicated portal for sellers to manage bookings, activities and earnings all in one place.",
  statPartners: "Active sellers",
  statBookings: "Bookings/month",
  welcomeBack: "Welcome back!",
  signInSubtitle: "Sign in to your account to continue",
  email: "Email",
  emailPlaceholder: "name@example.com",
  password: "Password",
  passwordPlaceholder: "••••••••",
  showPassword: "Show password",
  hidePassword: "Hide password",
  showConfirmPassword: "Show confirmation password",
  hideConfirmPassword: "Hide confirmation password",
  signIn: "Sign In",
  forgotPasswordLink: "Forgot password?",
  forgotPasswordTitle: "Forgot password",
  forgotPasswordSubtitle:
    "Enter your account email. If it matches a seller portal account, we will send a reset link.",
  forgotPasswordSubmit: "Send reset link",
  forgotPasswordSuccessToast: "If the address is valid, check your inbox.",
  forgotPasswordCheckEmail:
    "If the address is valid, we have sent instructions to your inbox.",
  forgotPasswordRulesReminder:
    "New passwords must be at least {{min}} characters and include uppercase and lowercase letters, a number, and a special character.",
  setPasswordTitle: "Set your password",
  setPasswordChecking: "Checking your link…",
  setPasswordInvalidLink:
    "This link is invalid or has expired. Ask staff for a new invite, or request a password reset from the login page.",
  setPasswordRequirementsTitle: "Password requirements",
  setPasswordRequirementMinLength: "At least {{min}} characters",
  setPasswordRequirementMixedCase: "Uppercase and lowercase letters (A–z)",
  setPasswordRequirementDigit: "At least one number",
  setPasswordRequirementSpecial: "At least one special character (e.g. ! @ #)",
  setPasswordTooCommonToast:
    "This password is too easy to guess. Choose a stronger, less common one.",
  setPasswordSubmit: "Save password",
  setPasswordSuccessToast: "Your password has been set. You can sign in now.",
  setPasswordDone:
    "Your password has been saved. You can close this page and sign in.",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  passwordConfirmRequired: "Please confirm your password",
  passwordsDoNotMatch: "Passwords do not match",
  setPasswordMinLength: "Password must be at least {{min}} characters",
  setPasswordMixedCase: "Include both uppercase and lowercase letters (A–z)",
  setPasswordRequireDigit: "Include at least one number",
  setPasswordRequireSpecial:
    "Include at least one special character (e.g. ! @ #)",
  backToLogin: "Back to sign in",
  testCredentialsTitle: "Test credentials",
} as const;
